import $ from 'jquery';
import $hub from '../utility/events-hub';
import { getRequestVerificationToken } from '../utility/ajax-helpers';

import storeList from './store-selector';

const opts = {
    storeSection: '.js-fav-store',
    newSection: '.js-fav-store-new',
    changeSection: '.js-fav-store-change',
    add: '.js-fav-store-add',
    addErr: '[data-selected-error]',
    remove: '.js-fav-store-remove',
    removeErr: '.js-fav-store-remove-err',
    name: '.js-fav-store-name',
    address: '.js-fav-store-address'
};

const addFavoriteStore = (e, data) => {
    const $btn = $(data.event.target);
    const store = $btn.data('store');
    const isReload = $btn.data('reload');
    const $addErr = $btn.parents(opts.storeSection).find(opts.addErr);

    $btn.addClass('loading');
    const params = {
        url: $btn.data('url'),
        type: $btn.data('method'),
        data: { store },
        headers: {
            ...getRequestVerificationToken
        }
    };

    $.ajax(params)
        .done((response) => {
            if (response.Success) {
                // Update favorite shop info
                $(opts.name).text(response.Store.Name);
                $(opts.address).text(response.Store.Address);
                $(opts.newSection).hide();
                $(opts.changeSection).show();
                if (isReload) {
                    window.location.reload();
                } else {
                    $btn.removeClass('loading');
                    $.fancybox.close();
                }
            } else {
                $addErr.text(`${response.ErrorMessage}`).show();
            }
        })
        .fail((error) => {
            $addErr.text(`${error.status} - ${error.statusText}`).show();
            $btn.removeClass('loading');
        });
};

const removeFavoriteStore = (evt) => {
    const $btn = $(evt.target);
    const isReload = $btn.data('reload');

    $btn.addClass('loading');

    const data = {
        url: $btn.data('url'),
        type: $btn.data('method'),
        headers: {
            ...getRequestVerificationToken
        }
    };

    const $removeErr = $(opts.removeErr);

    $.ajax(data)
        .done((response) => {
            if (response.Success) {
                $(opts.changeSection).hide();
                $(opts.newSection).show();
                if (isReload) {
                    window.location.reload();
                } else {
                    $btn.removeClass('loading');
                    $.fancybox.close();
                }
            } else {
                $removeErr.text(`${response.ErrorMessage}`).show();
            }
        })
        .fail((error) => {
            $removeErr.text(`${error.status} - ${error.statusText}`).show();
            $btn.removeClass('loading');
        });
};

const init = () => {
    const $addBtn = $(opts.add);
    const $removeBtn = $(opts.remove);

    if (!$addBtn.length && !$removeBtn.length) { return; }

    // Add favorite store
    if ($addBtn.length) {
        storeList.init();
        $hub.subscribe($hub.event.storeSelected, addFavoriteStore);
    }

    // Remove favorite store
    if ($removeBtn.length) {
        $removeBtn.on('click', removeFavoriteStore);
    }
};

export default {
    init,
    addFavoriteStore,
    removeFavoriteStore
};
